// extracted by mini-css-extract-plugin
export default {"plusIcon":"EmployersAddButton_plusIcon__pFEfr"};